import Vue from 'vue'
import VueDraggable from 'vuedraggable'
import * as Sentry from '@sentry/vue'

import { installCoreComponents } from './components/install'
import detectIE from '../common/detectIE'

import '../common/plugins'
import './plugins/axios'
import './plugins/vue-meta'

import store from './store'

import router from './router'
import App from './App.vue'
import UIkit from 'uikit'
import Icons from 'uikit/dist/js/uikit-icons'

Sentry.init({
  Vue,
  dsn: 'https://ad9cf58db33980c256663c7bc89f3043@o4510883326525440.ingest.us.sentry.io/4510883330850816',
  enableLogs: true,
});

Vue.config.productionTip = false
installCoreComponents(Vue)

UIkit.use(Icons)
Vue.component('vue-draggable', VueDraggable)

const ieVersion = detectIE()
if (ieVersion && ieVersion <= 11) {
  document.getElementById('ie-message').style.display = 'block'
} else {
  // @ts-ignore
  new Vue({
    router,
    store,
    render: h => h(App),
  }).$mount('#app')
}
